import { Accordion, Heading, Table } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';

const SkeletonCell = () => (
  <SkeletonContainer>
    <Bone css={{ marginTop: 'loose', marginBottom: 'default' }} />
  </SkeletonContainer>
);

const tableColumns = Array(8).fill('');

export const Skeleton = () => (
  <Table.Row>
    {tableColumns.map((_, index) => (
      <Table.Cell key={index}>
        <SkeletonCell />
      </Table.Cell>
    ))}
  </Table.Row>
);

export const LeadsTableSkeleton = () => {
  return (
    <Accordion.Root css={{ marginTop: 'loose' }}>
      <Accordion.Item value="leads-table">
        <Accordion.Header>
          <Heading level={2} textStyle="heading-xs">
            Recent conversations
          </Heading>
        </Accordion.Header>
      </Accordion.Item>
    </Accordion.Root>
  );
};
